import { Link } from 'react-router';
import { Tab, TabProps } from '@mui/material';

interface LinkTabProps extends TabProps {
    to: string;
}

export function LinkTab(props: LinkTabProps) {
    return <Tab LinkComponent={Link} {...props} />;
}
